<template>
	<div class="recharge">
		<div class="title">
			<div class="">
				{{i18n('25')}}
			</div>
			<div class="right" @click="$router.push('/rechargeRecord')">
				{{i18n('309')}}
			</div>
		</div>
		<div class="inner">
			<info @rechargeChange="rechargeChange" ref="info"></info>
			<div class="Tips">
				<div class="one">
					{{i18n('310')}}
				</div>
				<div class="two">
					* {{i18n('311')}}
				</div>
				<div class="two">
					* {{i18n('312')}}
				</div>
			</div>
			<payType :pay_method="params.pay_method" @pay_methodChange="pay_methodChange" @sub="sub"></payType>
		</div>
	</div>
</template>

<script>
	import pay from "@/utils/rechargePay.js"

	import info from "./components/info.vue"
	import payType from "./components/payType.vue"
	export default {
		name: "recharge",
		components: {
			info,
			payType
		},
		data() {
			return {
				params: {
					money: 0,
					pay_method: 2,
					platform: 7
				},
			}
		},
		methods: {
			//充值 金额 选择
			rechargeChange(data) {
				this.params.money = Number(data.cz)
			},
			pay_methodChange(type) {
				this.params.pay_method = type
			},
			async sub() {
				if (this.params.money < 1) {
					this.$message.error(this.i18n('313'))
					return false
				}
				let {
					res
				} = await pay(this.params)
				res = JSON.parse(res)
				if (this.params.pay_method != 5) {
					if (res.errno == 0) {
						let data = res.results
						let url = data.pay_url || data.api_url
						window.open(url)
					}
				} else {
					window.open(res.redirectUrl)
				}
				this.$confirm(this.i18n('314'), this.i18n('38'), {
					confirmButtonText: this.i18n('215'),
					cancelButtonText:this.i18n('216'),
					type: 'info',
					confirmButtonClass:"ele-qd"
				}).then(() => {
					this.$refs.info.getBalance()
				}).catch(() => {
					
				});
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.user.userInfo
			}
		},
		created() {

		},
		mounted() {

		}
	};
</script>

<style scoped>
	.Tips {
		width: 1032px;
		height: 142px;
		background: rgba(86, 171, 123, 0.10);
		border-radius: 12px;
		margin-top: -12px;
		padding: 34px 24px 0 24px;
		box-sizing: border-box;
		margin-bottom: 16px;
	}

	.Tips .one {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #56AB7B;
		font-weight: 400;
		margin-bottom: 16px;
	}

	.Tips .two {
		font-family: PingFangSC-Regular;
		font-size: 12px;
		color: #1D2129;
		font-weight: 400;
		margin-bottom: 8px;
	}

	.info {
		width: 1032px;
		height: 412px;
		background: #FFFFFF;
		border-radius: 12px;
	}

	.info .tit {
		width: 100%;
		height: 48px;
		border-bottom: 1px solid #56AB7B;
		padding-left: 24px;
		box-sizing: border-box;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #1D2129;
		font-weight: 500;
		line-height: 48px;
	}

	.inner {
		flex: 1;
		overflow-y: scroll;
		width: 100%;
	}

	.title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 69px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #1D2129;
		line-height: 69px;
		font-weight: 500;
	}
	
	.title .right {
		height: 32px;
		border-radius: 22.5px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #56AB7B;
		border: 1px solid #56AB7B;
		text-align: center;
		font-weight: 500;
		padding: 0 26px;
		line-height: 32px;
		cursor: pointer;
	}
	

	.recharge {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow-y: scroll;
	}
</style>
